const baseImageContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "howToPlay",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const baseInputContent = {
  type: "input",
  inputType: "text",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "howToPlay",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createMockPrizeEntry = (title: string, key: string, contentType: 'image' | 'input', inputType: string = '') => ({
  title,
  content: {
    ...(contentType === 'image' ? baseImageContent : baseInputContent),
    inputType,
    data: {
      ...baseImageContent.data,
      key,
      value: "",
    },
    ...(contentType === 'input' && { inputType }),
  },
  isRequired: false,
  readonly: false,
  isButton: contentType === 'image',
});

const mockPrize = [
  createMockPrizeEntry("Mock Prize Image", "mockPrizeImage", 'image'),
  createMockPrizeEntry("Mock Prize Name", "mockPrizeName", 'input', 'text'),
];

export { mockPrize };